/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import React from 'react';
import { getLastElement } from '../../helpers/breadcrumbs';

const BreadCrumb = ({ breadcrumbs }) => {
  if (!breadcrumbs || breadcrumbs.length === 0) return null;

  return (
    <div className="container">
      <ul
        className="breadcrumb-container"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {breadcrumbs.map((item, index) => (
          <li
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
            key={`breadcrumb_item__${index}`}
          >
            {getLastElement(index, breadcrumbs.length, item)}
            <meta content={`${index + 1}`} itemProp="position" />
          </li>
        ))}
      </ul>

      <style jsx>{`
        .breadcrumb-container {
          list-style: none;
          margin-left: 0px;
          margin-block-start: 0em;
          margin-block-end: 0px;
          margin-bottom: 20px;
          margin-inline-start: 0px;
          margin-inline-end: 0px;
          padding-inline-start: 0px;
          padding: 15px 0 0;
          width: 100%;
        }
        .breadcrumb-container > li {
          display: inline;
          color: #000;
        }
        .breadcrumb-container > li:after {
          font-family: 'Open Sans';
          content: '>';
          color: #000;
          position: relative;
          font-size: 1rem;
          margin: 0 8px 0 8px;
          top: -1px;
        }
        .breadcrumb-container > li:last-child:after {
          content: none;
        }
        @media only screen and (min-width: 768px) {
          .breadcrumb-container {
          }
          .breadcrumb-container > li:after {
            color: #000;
          }
        }
      `}</style>
      <style global jsx>{`
        .breadcrumb-container > li > a {
          cursor: pointer;
          color: #707070;
          text-transform: capitalize;
          text-decoration: none;
        }
        .breadcrumb-container > li:last-child > span {
          color: #000;
        }
        .breadcrumb-container > li > a:hover {
          color: #eb008c;
          text-decoration: underline;
        }

        @media only screen and (min-width: 768px) {
          .breadcrumb-container {
            text-shadow: none;
          }
        }
      `}</style>
    </div>
  );
};

export default BreadCrumb;

BreadCrumb.propTypes = {
  breadcrumbs: PropTypes.array,
};
